// jQuery
$(document).ready(function () {

console.log ('goschedule')
    // Define schedule: Each date has a specific div to show
    var schedule = [
        { date: '2024-12-13', show: '.day1promo' },
        { date: '2024-12-14', show: '.day2promo' },
        { date: '2024-12-15', show: '.day3promo' },
        { date: '2024-12-16', show: '.day4promo' },
        { date: '2024-12-17', show: '.day5promo' },
        { date: '2024-12-18', show: '.day6promo' },
        { date: '2024-12-19', show: '.day7promo' }
    ];

    // Function to get current date in Mountain Time (MT)
    function getMountainDate() {
        // Define Mountain Time offset from UTC
        var options = { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit' };
        var formatter = new Intl.DateTimeFormat('en-US', options);

        // Format as MM/DD/YYYY and convert to YYYY-MM-DD
        var parts = formatter.formatToParts(new Date());
        var year = parts.find(part => part.type === 'year').value;
        var month = parts.find(part => part.type === 'month').value.padStart(2, '0');
        var day = parts.find(part => part.type === 'day').value.padStart(2, '0');

        return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
    }

    // Get today's date in Mountain Time
    var today = getMountainDate();

    // Hide all divs initially
    $('.day1promo, .day2promo, .day3promo, .day4promo, .day5promo, .day6promo, .day7promo').hide();

    // Check the schedule for today's date
    var matched = false;
    schedule.forEach(function (entry) {
        if (entry.date === today) {
            $(entry.show).show(); // Show the matching div
            matched = true;
        }
    });

    // If no match, show the default div
    if (!matched) {
        $('#defaultDiv').show();
    }

console.log ('endschedule')
});
